import { ViewModel } from '../view-model';
import { CONFIG } from '../../core/config';
import { FailureMechanismReason } from './failure-mechanism-reason';

export class FailureMechanism implements ViewModel {
  friendlyTypeNameSingular: string = 'Failure Mechanism';
  apiRoute: string = CONFIG.apiRoutes.failureMechanism;

  selected: boolean;
  id: string;
  code: string;
  description: string;
  isSaved: boolean = false;
  reasons: FailureMechanismReason[] = [];

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.id = data.id;
    this.code = data.code;
    this.description = data.description;
    this.isSaved = data.isSaved;

    if (data.reasons) {
      this.reasons = data.reasons.map((details: FailureMechanismReason) => {
        const newReason = new FailureMechanismReason();
        newReason.loadFromJson(details);
        return newReason;
      });
    }
  }
}
